module.exports = __webpack_public_path__ + "img/四川天府新区籍田小学.e34d1f0e.jpg";